export default function Naming({ question }) {
  return <img src={question.imageUrl} alt="Задание" className="max-h-[50vh] rounded-2xl shadow-lg border border-border object-contain" />;
}